class SolutionVendors {
	static block_name = 'b-solution-vendors';

	constructor($elem) {
		this.$elem = $elem;
	}

	onInit() {
		const it = this;
		const $itemsBtn = it.$elem.find(`.${SolutionVendors.block_name}__items-btn`);

		$itemsBtn.click(function() {
			it.$elem.find(`.${SolutionVendors.block_name}__item.hide`).slice(0,4).removeClass('hide');
			if(it.$elem.find(`.${SolutionVendors.block_name}__item.hide`).length == 0) {
				$itemsBtn.remove();
			}
		});
	}
}

export default SolutionVendors;